import api from '../../api';
import { D4signDocument, D4signMinute } from './types';

export async function sendMinuteForD4signRequest(
  createMinuteForD4sign: D4signMinute,
) {
  try {
    const response = await api().post(
      '/sign-integration/d4sign/minute',
      createMinuteForD4sign,
    );

    return response;
  } catch (error) {
    console.error('Error postSenderD4SignMinute', error);
    return null;
  }
}

export async function sendDocumentForD4signRequest(
  createMinuteForD4sign: D4signDocument,
) {
  try {
    const response = await api().post(
      `/sign-integration/d4sign/document`,
      createMinuteForD4sign,
    );

    return response;
  } catch (error) {
    console.error('Error postSenderD4SignDocument', error);
    return null;
  }
}
